<template>
    <div class="MuiBox-root css-3d0ymh">
        <div class="MuiBox-root css-19vwmxk" data-testid="screen-business_details" tabindex="-1">
            <div class="page-title title-center solid-bg breadcrumbs-off breadcrumbs-mobile-off page-title-responsive-enabled">
                <div class="wf-wrap">

                    <div class="page-title-head hgroup"><h1>Thank You</h1></div>			</div>
            </div>
            <div id="main" class="sidebar-none sidebar-divider-vertical">


                <div class="main-gradient"></div>
                <div class="wf-wrap">
                    <div class="wf-container-main">
                        <div id="content" class="content" role="main">

                            <p>Thank You. Your submission has been successful. We will be in touch shortly with the next steps. We look forward to building and developing a long lasting relationship with you.</p>
                            <span class="cp-load-after-post"></span>
                            <div class="homepage-link-wrap">
                                <RouterLink to="/" class="homepage-link zb-button txt-button-lg button-growth button-primary"> Homepage </RouterLink>
                            </div>
                        </div><!-- #content -->
                    </div><!-- .wf-container -->
                </div><!-- .wf-wrap -->
            </div>
        </div>
    </div>
</template>

<style scoped>
.homepage-link-wrap {
    text-align: center;
    margin-top: 45px;
}
.homepage-link {

}
</style>
